/**
 * Updates the UI of the 'Add to basket' button.
 * @param {HTMLButtonElement} button - The 'Add to basket' button event listener.
 * @param {boolean} atbProcessing - The 'action is loading' check.
 * @param {boolean} atbComplete - The 'action is complete' check.
 * @param {string} depositPrice - The deposit price if present.
 */
export function updateButton(
	button: HTMLButtonElement,
	atbProcessing: boolean,
	atbComplete: boolean,
	depositPrice: string | null,
): void {
	if (!button) return;

	const buttonTextDefault = depositPrice
		? 'Reserve for &pound;' + depositPrice
		: ('Add to basket' as string);
	const buttonTextComplete = 'Added' as string;

	// Remove preexisting temporary button states/classes
	if (button.innerHTML == buttonTextComplete) button.innerHTML = '';
	if (button.classList.contains('btn-loading')) button.classList.remove('btn-loading');
	if (button.classList.contains('btn-complete')) button.classList.remove('btn-complete');

	// Change button content when first clicking the button.
	if (atbProcessing) {
		button.classList.add('btn-loading');
		button.innerHTML = '';
	}

	// Change button content when adding product to basket has completed.
	if (atbComplete) {
		button.classList.add('btn-complete');
		button.innerHTML = `
			<i class="fa-solid fa-check"></i>
			${buttonTextComplete}
		`;

		setTimeout(function () {
			button.innerHTML = buttonTextDefault;
			button.classList.remove('btn-complete');
		}, 2000);
	}
}
